/** Handbook policy #32 — Bills & Payables (seed: scripts/seed-handbook-data/policy-32-body.html). */
export const BILLS_PAYABLES_HANDBOOK_POLICY_NUMBER = '32';

export const BILLS_PAYABLES_HANDBOOK_HREF = `/people/handbook/${BILLS_PAYABLES_HANDBOOK_POLICY_NUMBER}`;
